import { useState, useEffect } from "react";

import React from "react";
import { Button, Card } from "react-bootstrap";
import TestimonialsTable from "./TestimonialsTable";
import TestimonialsModal from "./TestimonialsModal";

import axios from "axios";
import Loader from "../../components/Loader";
import { getHostName } from "../../helpers/utils";

const Testimonials = () => {
  const hostname = getHostName();

  const [dataList, setDataList] = useState([]);

  const [loader, setLoader] = React.useState(false);

  const [payload, setPayload] = React.useState({});

  //  modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getDataList();
  }, []);

  const getDataList = () => {
    axios
      .get(`${hostname}/api/testimonials/get-all-testimonials`)
      .then((res) => {
        console.log(res.data);
        setDataList(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const createEntry = () => {
    let obj = {};
    obj.loadType = "Add Testimonial";

    setPayload({ ...obj });
    handleShow();
  };

  const viewEntry = (obj) => {
    obj.loadType = "View Testimonial";

    setPayload({ ...obj });
    handleShow();
  };

  const updateEntry = (obj) => {
    obj.loadType = "Update Testimonial";

    setPayload({ ...obj });
    handleShow();
  };

  const deleteEntry = (obj) => {
    obj.loadType = "Delete Testimonial";

    setPayload({ ...obj });
    handleShow();
  };

  if (loader) {
    return <Loader />;
  } else {
    return (
      <div>
        <Card>
          <Card.Body className="overflow-hidden" style={{ minHeight: "90vh" }}>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="mb-3"
            >
              <h4>Testimonials</h4>

              <Button variant="primary" size="sm" onClick={createEntry}>
                + Add
              </Button>
            </div>

            <br />
            <TestimonialsTable
              list={dataList}
              viewEntry={viewEntry}
              updateEntry={updateEntry}
              deleteEntry={deleteEntry}
            />
            <br />

            <TestimonialsModal
              show={show}
              handleClose={handleClose}
              payload={payload}
              setPayload={setPayload}
              getAllData={getDataList}
              hostname={hostname}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
};

export default Testimonials;
